export const CustomerCareActivity = [
    {
        "id": "NEW",
        "name": "Mới"
    },
    {
        "id": "CALL",
        "name": "Gọi cho khách"
    },
    {
        "id": "STUDENT_TEST",
        "name": "Học sinh test"
    },
    {
        "id": "MEETING_CLASS",
        "name": "Gặp tại lớp"
    },
    {
        "id": "STUDENT_CARE",
        "name": "Chăm sóc học sinh"
    },
    {
        "id": "TODO",
        "name": "Đang làm"
    },
    {
        "id": "COMPLETE",
        "name": "Hoàn thành"
    }
]